import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const RankingTable = ({
  data,
  searchEnabled,
  longDescription,
  ofCountry,
  inCountry,
  inCity,
}) => {
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");

  useEffect(() => {
    initFilters1();
  }, []);

  const initFilters1 = () => {
    setFilters1({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue1("");
  };

  const renderHeader1 = () => {
    if (searchEnabled) {
      return (
        <div className="flex justify-content-end">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              value={globalFilterValue1}
              onChange={onGlobalFilterChange1}
              placeholder="Keyword search"
            />
          </IconField>
        </div>
      );
    }
  };

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = { ...filters1 };
    _filters1["global"].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  };

  const header1 = renderHeader1();

  const countryTemplate = (rowData) => {
    return (
      <div style={{ display: "flex" }}>
        <img
          src={"flags/" + rowData["iso"].toLowerCase() + ".svg"}
          alt=""
          width="17em"
          style={{ marginRight: "0.7em" }}
        />
        {rowData["iso-en"]}
      </div>
    );
  };

  const isoTemplate = (rowData) => {
    return rowData["iso"].toUpperCase();
  };

  return (
    <DataTable
      value={data}
      responsiveLayout="scroll"
      header={header1}
      filters={filters1}
      filterDisplay="menu"
      paginator={longDescription}
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="{first} to {last} of {totalRecords} results"
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
    >
      <Column field="iso" header="ISO" body={isoTemplate} sortable></Column>
      {inCountry && (
        <Column
          field="iso-en"
          header="In country"
          body={countryTemplate}
          sortable
        ></Column>
      )}
      {ofCountry && (
        <Column
          field="iso-en"
          header="Of country"
          body={countryTemplate}
          sortable
        ></Column>
      )}
      {inCity && (
        <Column
          field="iso-en"
          header="Country"
          body={countryTemplate}
          sortable
        ></Column>
      )}
      {inCity && <Column field="city" header="In city" sortable></Column>}
      <Column
        field="embassies-and-high-commissions"
        header="Embassies and high commissions"
        sortable
      ></Column>
      <Column field="consulates" header="Consulates" sortable></Column>
      <Column field="other-posts" header="Other posts" sortable></Column>
      <Column field="total-posts" header="Total posts" sortable></Column>
      <Column
        field="ranking-embassies-and-high-commissions"
        header="Ranking (embassies and high commissions)"
        sortable
      ></Column>
      <Column
        field="ranking-total-posts"
        header="Ranking (total posts)"
        sortable
      ></Column>
      <Column
        field="permanent-missions"
        header="Permanent missions"
        sortable
      ></Column>
    </DataTable>
  );
};

export default RankingTable;
